import { connect, useSelector } from 'react-redux';
import get from 'lodash/get';
import DmCustomEmbed from '../../molecules/DmCustomEmbed';
import React from 'react';

import './story-page-livetv-widget.m.css';
import ReactPlayer from 'react-player';
import array, { string } from 'prop-types';

const StoryPageLivetvWidget = ({ story, datalayerFields, mostRead, isLiveBlog, liveStreamUrl }) => {
  const dmConfig = useSelector(state =>
    get(state, ['qt', 'config', 'integrations', 'dailymotion'], {})
  );

  const playerId = get(dmConfig, ['player-id', 'live-tv-with-playlist'], 'x7nb2');
  const liveStreamId = get(dmConfig, ['livestream', 'bqlive'], 'x890v1q');
  const channelId = get(dmConfig, ['channel', 'id'], 'bloombergquint');
  const playListId = get(dmConfig, ['playlist-id', 'bq-videos'], 'x7ep2j');


  return (
    <div styleName="live-tv-player player-wrapper">
      <ReactPlayer
        styleName='react-player'
        url={liveStreamUrl}
        width='100%'
        height='100%'
        controls={true}
        playing={true}
        playsinline={true} //this attribute for iOS autoplaying in non-fullscreen
        progressInterval={1000}
        volume={null}
        muted={true}
      />
    </div>
  );
};

StoryPageLivetvWidget.propTypes = {
  liveStreamUrl: string
};

const mapStateToProps = state => {
  return {
    liveStreamUrl: get(state, ['qt', 'config', 'publisher', 'live_stream_url'], ["https://dai.google.com/linear/hls/event/QuU6z3GSTDaXuLL9Hs5A5Q/master.m3u8"]),
  };
};

export default connect(mapStateToProps, null)(StoryPageLivetvWidget);
